import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {observer} from "mobx-react";
import {KeyboardArrowLeft} from "../../icons/keyboard-arrow/keyboard-arrow-left";
import {KeyboardArrowRight} from "../../icons/keyboard-arrow/keyboard-arrow-right";
import classNames from "classnames";
import styles from "./breadcrumbs.module.scss";

class BreadcrumbsArrowProps extends BaseProps {}

export const BreadcrumbsArrow = observer(({controller}: BreadcrumbsArrowProps) => {
  const {device} = controller
  const {isRtl} = device

  return isRtl ? <KeyboardArrowLeft className={classNames(styles.arrow)}/> : <KeyboardArrowRight className={classNames(styles.arrow)}/>
});
